<template>
  <!-- 遮罩 -->
  <div class="background-info" v-show="fullscreenLoading">
<!--    <img src="/static/img/Loading.svg" :style="{height: `${imgHeight}px`, width: `${imgWidth}px`}">-->
    <img src="/static/img/waitingNew.svg" style="margin-top: 15%;height: 40%;width: 100%;left: 0">
  </div>
</template>

<script>
export default {
  name: 'publicMask',
  props: ['fullscreenLoading'],
  data () {
    return {
      imgHeight: document.documentElement.clientHeight,
      imgWidth: document.documentElement.clientWidth
    }
  },
  mounted () {},
  methods: {
    init () {}
  }
}

</script>

<style scoped>
.background-info{background-color: rgba(255,255,255,.7);margin: 0;top: 0;right: 0;bottom: 0;left: 0;-webkit-transition: opacity .3s;transition: opacity .3s;position: fixed;z-index: 2000;}
.background-info img{position: fixed;z-index: 2003;width: 1500px;height: 600px;}
</style>



// WEBPACK FOOTER //
// src/components/public/publicMask.vue